<template>
  <div v-if="me" class="py-8 px-8">
    <slot name="memorandum" />

    <p class="text-center">
      {{ $moment().format('YYYY') }}년 {{ $moment().format('MM') }}월 {{ $moment().format('DD') }}일
    </p>

    <p class="text-center">
      성명 <strong>{{ me.name }}</strong>
    </p>

    <v-dialog v-model="dialog" width="400">
      <template v-slot:activator="{ on, attrs }">
        <div style="width: 100%; max-width: 400px" class="mx-auto">
          <v-btn color="white" height="120" block v-bind="attrs" v-on="on" class="width-100">
            <template v-if="!signImage">
              본인의 성함을 정자로 서명해주세요.
              <v-icon>mdi-pencil</v-icon>
            </template>
            <v-img v-else :src="signImage" />
          </v-btn>
        </div>
      </template>

      <v-card>
        <v-card-title class="text-h5"> 서명란 </v-card-title>

        <v-card-text class="pad_wrapper pb-6">
          <VueSignaturePad
            class="pad"
            ref="signaturePad"
            :options="{
              onBegin: () => {
                $refs.signaturePad.resizeCanvas()
              },
            }"
          />
          <v-slide-y-transition>
            <p v-if="isSignError" class="position--absolute error--text text--center">
              사인을 해주세요.
            </p>
          </v-slide-y-transition>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="sign"> 완료 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      isSignError: false,
      signImage: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  methods: {
    sign() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty === true) {
        this.isSignError = true
      } else {
        this.$emit('sign', data)
        this.signImage = data
        this.dialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pad_wrapper {
  height: 120px;

  .pad {
    position: relative;
    z-index: 2;
    -ms-user-select: none;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
}

::v-deep .v-btn__content {
  width: 100%;
}
</style>
